module.exports = __webpack_public_path__ + "img/search-black.ade66452.svg";